import React from 'react';
import * as Utils from "../../../inc/Utils";
import toast, { Toaster } from 'react-hot-toast';

import {confirmAlert} from "react-confirm-alert";
import Role from "../../../inc/Role";
import {NavLink, useParams, useNavigate} from "react-router-dom";
import * as Icon from "react-bootstrap-icons";
import {Config} from '../../../Config'
import Select from 'react-select'
import moment from "moment-timezone";

export default function GenerateGroupEdit() {
    let {encode} = useParams();
    let decode = Utils.decodeItem(encode);
    let generateGroupId = decode.id;

    const roles = new Role();
    let userId = roles.loginUserId;

    let btnTextDefault = 'อัพเดตข้อมูล';
    let btnTextLoading = 'กำลังอัพเดต..';
    let [isLoading, setLoading] = React.useState(false);
    let [data, setData] = React.useState('');
    let [statusChecked, setStatusChecked] = React.useState(false);
    let [type, setType] = React.useState(null);
    let [typeId, setTypeId] = React.useState(null);
    let [masterUrlFor, setMasterUrlFor] = React.useState(null);
    let [masterUrlForId, setMasterUrlForId] = React.useState(null);
    let [agency, setAgency] = React.useState(null);

    const navigate = useNavigate();

    let refName = React.useRef();

    React.useEffect(() => {
        (async function() {
            try {
                const resAgency = await Utils.getAgency();

                const resView = await getView();
                refName.current.value = resView.name;
                setData(resView);
                setStatusChecked(resView.status===1);

                const resType = await Utils.getType();
                setType(resType);
                setTypeId({
                    id: resView.typeId,
                    name: Utils.generateUTMType(resView.typeId)
                });

                const resMasterUrlFor = await Utils.getMasterURLFor();
                setMasterUrlFor(resMasterUrlFor);
                if(resView.masterUrlFor) {
                    setMasterUrlForId(resMasterUrlFor.filter(e => e.id === resView.masterUrlFor)[0]);
                }

                if(resAgency) {
                    resAgency.map((rs, i) => {
                        rs.checked = resView.items.filter(e => e.agencyId === rs.id).length > 0;
                    });
                    setAgency(resAgency);
                }
            } catch (e) {
                toast.error(e.message);
            }
        })();
    }, []);

    async function getView() {
        const response = await fetch(Config.url.API_URL +'/api/generateGroup/view', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': roles.accessToken
            },
            body: JSON.stringify({
                id: generateGroupId
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    const onUpdate = () => {
        let name = refName.current.value;

        let items = [];
        if(roles.permissionId === Utils.SUPER_ADMIN_ID) {
            let checkboxes = document.getElementsByName('agencyIds[]');
            for (let i = 0; i < checkboxes.length; i++) {
                if(checkboxes[i].checked) {
                    items.push({'agencyId': checkboxes[i].value});
                }
            }
        }
        else {
            items.push({'agencyId': roles.agencyId});
        }

        if(!name) {
            toast.error("กรุณาระบุ ชื่อ Group");
            refName.current.focus();
        }
        else if(!typeId) {
            toast.error("กรุณาระบุ Type");
        }
        else if(typeId && typeId.id === Utils.GENERATE_TYPE_MASTER_URL && !masterUrlForId) {
            toast.error("กรุณาระบุ Master URL For");
        }
        else if(items.length <= 0) {
            toast.error("กรุณาระบุ Agency อย่างน้อย 1 รายการ");
        }
        else {
            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ต้องการอัพเดตข้อมูล ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: () => {
                            setLoading(true);

                            let statusChecked = document.getElementsByName('statusChecked');

                            const body = {
                                items: items,
                                id: data.id,
                                name: name,
                                currentName: data.name,
                                status: statusChecked[0].checked ? 1:0,
                                updatedBy: userId,
                                updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                            };
                            fetch(Config.url.API_URL +'/api/generateGroup/update', {
                                method: 'POST',
                                body: JSON.stringify(body),
                                headers: {
                                    'Content-Type':'application/json',
                                    'x-access-token': roles.accessToken
                                }
                            }).then(response => {
                                if(response.ok) {
                                    return response.json();
                                }
                                else {
                                    return response.json().then(err => Promise.reject(err));
                                }
                            }).then(result => {
                                if(result) {
                                    toast.success("อัพเดตข้อมูลเรียบร้อย");
                                    setTimeout(function () {
                                        navigate('/generateGroup', {replace: true});
                                    }, 1500);
                                }
                                else {
                                    setLoading(false);
                                }
                            }).catch(err => {
                                toast.error(err.message);
                            })
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {}
                    }
                ]
            });
        }
    };

    const onChangeTypeId = (obj) => setTypeId(obj);
    const isClearable = () => {
        setTypeId(null);
    };

    const onChangeMasterUrlFor = (obj) => {
        setMasterUrlForId(obj);
    };

    return (
        <main>
            <div className="row table-toolbar mb-2">
                <div className="col-6 align-self-center">
                    <div className="h6 d-inline"><span className="text-success">&#8226;</span> Generate Group</div>
                    <span className="ms-1">/</span> <span className="text-muted">Edit</span>
                </div>
                <div className="col-6 text-end align-self-center toolbars">
                </div>
            </div>
            <div className="rounded bg-white p-4 shadow">
                <div className="row">
                    <div className="col-12 col-md-6">
                        <form className="row g-3">
                            <div className="col-12">
                                <label htmlFor="name" className="form-label">ชื่อ Group <span className="text-danger">*</span></label>
                                <input type="text" className="form-control" id="name" ref={refName} maxLength={100} />
                            </div>
                            <div className="col-12">
                                <label htmlFor="campaignTypeId" className="form-label"> Type <span className="text-danger">*</span></label>
                                <Select
                                    isDisabled={true}
                                    isClearable={isClearable}
                                    classNamePrefix="form-select-search"
                                    options={type}
                                    onChange={(event) => onChangeTypeId(event)}
                                    value={typeId}
                                    getOptionValue={(option) => `${option.id}`}
                                    getOptionLabel={(option) => `${option.name}`}
                                />
                            </div>
                            <div className={"col-12" + (typeId && typeId.id === Utils.GENERATE_TYPE_MASTER_URL ? '':' d-none')}>
                                <label htmlFor="masterURLFor" className="form-label">Master URL For <span className="text-danger">*</span></label>
                                <Select
                                    isDisabled={true}
                                    classNamePrefix="form-select-search"
                                    options={masterUrlFor}
                                    onChange={(event) => onChangeMasterUrlFor(event)}
                                    value={masterUrlForId}
                                    getOptionValue={(option) => `${option.id}`}
                                    getOptionLabel={(option) => `${option.id} : ${option.name}`}
                                />
                            </div>
                            <div className={"col-12" + (roles.permissionId === Utils.SUPER_ADMIN_ID ? '':' d-none')}>
                                <label htmlFor="agencyx" className="form-label">Agency</label>
                                {
                                    agency === null || agency.length <= 0 ? (<p>ไม่พบข้อมูล</p>) :
                                        agency.map((row, index) => {
                                            let chkId = 'agencyCheck' + row.id;
                                            return (
                                                <div key={index} className="form-check ms-2">
                                                    <input className="form-check-input" name="agencyIds[]" type="checkbox" value={row.id} id={chkId} defaultChecked={row.checked} />
                                                    <label className="form-check-label" htmlFor={chkId}>
                                                        {row.name} {row.isEncrypt ? <span className="badge bg-secondary small">encrypt</span>:''}
                                                    </label>
                                                </div>);
                                        })
                                }
                            </div>

                            <div className="col-12">
                                <label htmlFor="statusx" className="form-label">สถานะ</label>
                                <div className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" name="statusChecked" id="status" checked={statusChecked} onChange={e => {setStatusChecked(e.target.checked)}} />
                                    <label className="form-check-label" htmlFor="status"></label>
                                </div>
                            </div>
                            <div className="col-12">
                                <button type="button" className="btn btn-primary" onClick={onUpdate} disabled={isLoading}><span
                                    className={isLoading ? 'spinner-grow spinner-grow-sm' : 'd-none'}></span> {isLoading ? btnTextLoading : btnTextDefault}</button>
                                <NavLink className="btn btn-sm btn-light ms-2" to='/generateGroup'><span><Icon.ArrowLeft/> กลับไป</span></NavLink>
                                <Toaster position="bottom-right" />
                            </div>
                        </form>
                    </div>
                    <div className="col-12 col-md-6"></div>
                </div>
            </div>
        </main>
    );
} 